import {Divider, HStack, Text, useTheme} from '@chakra-ui/react'

interface Props {
  content: string
}

const DividerWithText = ({content}: Props) => {
  const theme = useTheme()
  return (
    <HStack w='full'>
      <Divider variant='separatorLight' />
      <Text minW='fit-content' variant='medium' color={theme.colors.text.light}>
        {content}
      </Text>
      <Divider variant='separatorLight' />
    </HStack>
  )
}
export default DividerWithText
